import { Timestamp } from "firebase/firestore";
export const candidateList = [
    {
        name: 'Jorge',
        lastName: 'Barrera',
        education: [
            {
                fieldStudy: 'Primary',
                institution: 'Padre Andre Coindre',
                graduationDate: Timestamp.fromDate(new Date('2011-01-01')),
                degree: 'Basic'
            },
            {
                fieldStudy: 'Ingenieer Informatic',
                graduationDate: Timestamp.fromDate(new Date('2021-01-01')),
                degree: 'University',
                institution: 'DUOC UC'
            },
            {
                institution: 'INCO',
                graduationDate: Timestamp.fromDate(new Date('2016-09-09')),
                fieldStudy: 'Secundary',
                degree: 'Middle'
            }
        ],
        experience: [
            {
                dateStart: Timestamp.fromDate(new Date('2011-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2012-01-01')),
                actualPosition: true,
                description: 'As a [title] at [company], I successfully led a team of professionals and implemented strategies that resulted in a significant increase in revenue. I played a key role in enhancing operational efficiency and reducing costs through process improvements. Additionally, I developed and maintained strong relationships with key clients, resulting in an increase in customer satisfaction and repeat business. Overall, I achieved measurable outcomes and contributed to the overall success of the organization.',
                company: 'City',
                title: 'New position'
            },
            {
                dateStart: Timestamp.fromDate(new Date('2011-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2012-01-01')),
                actualPosition: true,
                description:
                    'As a [title] at [company], I successfully led a team of professionals and implemented strategies that resulted in a significant increase in revenue. I played a key role in enhancing operational efficiency and reducing costs through process improvements. Additionally, I developed and maintained strong relationships with key clients, resulting in an increase in customer satisfaction and repeat business. Overall, I achieved measurable outcomes and contributed to the overall success of the organization.',
                company: 'City',
                title: 'New position'
            },
            {
                description:
                    'Décrivez vos responsabilités et vos réalisations en termes d’impact et de résultats. Citez des exemples tout en restant concis.',
                dateStart: Timestamp.fromDate(new Date('2013-01-01')),
                title: 'New position',
                dateEnd: Timestamp.fromDate(new Date('2014-01-01')),
                company: 'New position / City',
                actualPosition: false
            },
            {
                company: 'New position / City',
                dateStart: Timestamp.fromDate(new Date('2015-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2016-01-01')),
                actualPosition: false,
                description: 'Décrivez vos responsabilités et vos réalisations en termes d’impact et de résultats. Citez des exemples tout en restant concis.',
                title: 'New position',
            },
            {
                actualPosition: false,
                title: 'Long',
                dateStart: Timestamp.fromDate(new Date('2011-01-01')),
                dateEnd: Timestamp.fromDate(new Date('2017-01-01')),
                company: 'Long / Mapping Cie',
                description: 'Décrivez vos responsabilités et vos réalisations en termes d’impact et de résultats. Citez des exemples tout en restant concis.',
            }
        ],
        skills: [
            { level: 5, name: 'Inventory' },
            { name: 'Conflict Resolution', level: 5 },
            { level: 5, name: 'Health & Safety' },
            { level: 5, name: 'Proactive' },
            { name: 'Languages', level: 5 }]
    }


]

export const candidateFrance = [
    {
        'name': 'Candidate 1',
        'education': [
            {
                'fieldStudy': 'Business Administration (MBA)',
                'institution': 'Université de Sherbrooke',
                'graduationDate': Timestamp.fromDate(new Date('2013-02-02')),
                'degree': 'MBA'
            },
            {
                'fieldStudy': 'Commerce (Major: Marketing)',
                'institution': 'Université Concordia',
                'graduationDate': Timestamp.fromDate(new Date('2003-02-02')),
                'degree': 'Baccalauréat '
            },
            {
                'fieldStudy': 'Administration',
                'institution': 'Cégep John Abbott',
                'graduationDate': Timestamp.fromDate(new Date('2000-02-02')),
                'degree': "Diplôme d'Études Collégiales"
            }
        ],
        'experience': [
            {
                'dateStart': Timestamp.fromDate(new Date('2018-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2023-02-02')),
                'actualPosition': false,
                'description': "Gestion de territoire : Responsabilité de la gestion, planification, et analyse de marché d'un territoire pour surpasser les objectifs de vente. \nPromotion de produit : Compétence en promotion auprès de distributeurs via des stratégies marketing ciblées pour booster visibilité et ventes.\nService client : Engagement dans un service client de qualité, offrant assistance proactive et réactive pour satisfaction et fidélisation.\nService après-vente : Gestion du service après-vente pour répondre rapidement aux demandes, assurant le maintien de relations de confiance.\nRéalisations : Distinction par le Club du Président en 2018 et 2020 pour performances exceptionnelles en ventes et leadership, preuve d'un engagement vers l'excellence.",
                'company': 'Techo-Bloc Inc.',
                'title': 'Représentant des ventes'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2015-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2017-02-02')),
                'actualPosition': false,
                'description': 'Vente, gestion et coordination de travaux de rénovation',
                'company': 'Gestion Pur H.D. Inc',
                'title': 'Travailleur autonome'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2004-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2005-02-02')),
                'actualPosition': false,
                'description': 'Logistique de transport\nNégociation avec client, transporteur et fournisseur\nVentes de services',
                'company': 'CH Robinson Worldwide',
                'title': 'Représentant des ventes'
            }
        ],
        'skills': [
            { 'name': 'Ventes', 'level': 5 },
            { 'name': 'Autonomie', 'level': 5 },
            { 'name': 'Service-Clientele', 'level': 4 },
            { 'name': 'Négociation', 'level': 4 },
            { 'name': 'Excel', 'level': 4 }]
    },
    {
        'name': 'Candidate 2',
        'education': [
            {
                'fieldStudy': 'Assurance de dommages',
                'institution': 'Cégep de Jonquière, Québec',
                'graduationDate': Timestamp.fromDate(new Date('2019-02-02')),
                'degree': 'Attestation d’études collégiales'
            },
            {
                'fieldStudy': 'Assurance maladie et accident',
                'institution': 'Combined Assurances, Granby',
                'graduationDate': Timestamp.fromDate(new Date('2013-02-02')),
                'degree': 'Formation en assurance'
            },
            {
                'fieldStudy': 'Vente d’assurances',
                'institution': 'Combined Assurances, Granby',
                'graduationDate': Timestamp.fromDate(new Date('2013-02-02')),
                'degree': 'Formation de vente'
            }
        ],
        'experience': [
            {
                'dateStart': Timestamp.fromDate(new Date('2022-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2023-02-02')),
                'actualPosition': false,
                'description': "Planifier, répartir et superviser le travail des participants aux ressources humaines.\n Traiter les ventes, les feuilles de temps et corriger les tests d’admission.\n Intervenir auprès des participants concernant leur rendement et leurs enjeux.\n Participer aux réunions de coordination interdépartementale et monter les horaires.\n Maîtrise des tâches et du rôle dans un court délai afin d'assurer le bon fonctionnement de l'organisme à seulement deux employés.",
                'company': "Entreprise d’entraînement PlastiGroulx",
                'title': 'Technicienne aux opérations : ressources humaines et ventes'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2020-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2021-02-02')),
                'actualPosition': false,
                'description': "Rechercher les meilleurs fournisseurs et y référer le client.\n Négocier avec différents partenaires d'assurance et offrir la meilleure solution pour le client.\n Servir d'intermédiaire entre le client et l'expert en sinistre.",
                'company': 'Consilium Assurance',
                'title': 'Courtière en assurance de dommages'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2019-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2020-02-02')),
                'actualPosition': false,
                'description': 'Analyser les besoins des clients et vérifier les rapports des inspecteurs.\n Donner suite aux réclamations et répondre aux requêtes de la clientèle.\n Accompagner émotionnellement le client dans la démarche.',
                'company': 'SCM Indemnipro',
                'title': 'Experte en sinistre'
            }],
        'skills': [
            { 'name': 'Assurance', 'level': 4 },
            { 'name': 'Gestion', 'level': 4 },
            { 'name': 'Ventes', 'level': 3 },
            { 'name': 'Ressources Humaines', 'level': 3 },
            { 'name': 'Excel', 'level': 3 }
        ]
    },
    {
        'name': 'Candidate 3',
        'education': [{
            'fieldStudy': 'Business Administration',
            'institution': 'Hult International Business School ',
            'graduationDate': Timestamp.fromDate(new Date('2022-02-02')),
            'degree': 'Maîtrise en Administration des Affaires (EMBA)'
        },
        {
            'fieldStudy': 'Hospitality Management',
            'institution': 'Université Cornell ',
            'graduationDate': Timestamp.fromDate(new Date('2017-02-02')),
            'degree': 'Certificat en Gestion Hôtelière'
        },
        {
            'fieldStudy': '',
            'institution': '',
            'graduationDate': Timestamp.fromDate(new Date('1992-02-02')),
            'degree': 'Diplôme d’Études Collégiales'
        }],
        'experience': [
            {
                'dateStart': Timestamp.fromDate(new Date('2022-02-02')),
                'dateEnd': Timestamp.fromDate(new Date()),
                'actualPosition': true,
                'description': "Consultation en gestion hôtelière englobant l'ensemble du cycle de vie du produit hôtelier, y compris l'aspect nourriture et boisson.\nPlanification et développement hôtelier.\nGestion des actifs hôteliers.\nFourniture de conseils stratégiques.\nAccompagnement opérationnel en hôtellerie et pour le service de nourriture et boisson.",
                'company': 'Hoteleri',
                'title': 'Consultant Senior'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2023-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2023-02-02')),
                'actualPosition': false,
                'description': 'Mandat avec l’objectif de réorienter la gestion de ce magnifique hôtel de 51 chambres.\nAmélioration des résultats financiers de 33% sur une période de 6 mois\nChangement de la culture des employés, révision de l’organigramme, restructure des départements\nCréation d’un plan commercial complet.',
                'company': 'Hotel 5 etoiles',
                'title': 'Directeur Général'
            },
            {
                'dateStart': Timestamp.fromDate(new Date('2021-02-02')),
                'dateEnd': Timestamp.fromDate(new Date('2021-02-02')),
                'actualPosition': false,
                'description': "Préparation en vue de la préouverture et gestion de tous les restaurants de l'hôtel, transféré de l'interne au sein du groupe hotelier pour ce projet spécial d'ouverture d’un hôtel ultra-luxueux.\nn Ouverture de 8 restaurants et bars, recrutement et formation d'une équipe de 150 employés",
                'company': 'Raffles The Palm - Dubaï, Émirats Arabes Unis',
                'title': 'Directeur de la Restauration'
            }],
        'skills': [{ 'name': 'Gestion hôtelière', 'level': 5 },
        { 'name': 'Planification stratégique', 'level': 4 },
        { 'name': 'Conseil opérationnel', 'level': 4 },
        { 'name': 'Développement commercial', 'level': 4 },
        { 'name': "Leadership d'équipe", 'level': 5 }]
    }
]